import { createStore, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk"
import * as commonReducers from './reducers/common.reducers'


const reducers = combineReducers({
    ...commonReducers
})
export default createStore(reducers, applyMiddleware(thunk))